import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sf-container tw-text-center" }
const _hoisted_2 = { class: "tw-my-8" }
const _hoisted_3 = { class: "tw-text-primary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Your payment has been successful.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "You should have received an email with your username and password.", -1)
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckSvg = _resolveComponent("CheckSvg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CheckSvg, {
        scale: 2,
        class: "result-ok2 tw-block tw-mx-auto"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      (_ctx.showLoginLink)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createTextVNode(" You can now "),
            _createElementVNode("a", {
              href: "",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showLogin && _ctx.showLogin(...args)), ["prevent"]))
            }, "log in"),
            _createTextVNode(". ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}